import type { Platform, ShareContent } from '../types';
import { buildShareUrl } from '../utils/url';
import { PlatformRegistry } from './registry';

export const reddit: Platform = {
  id: 'reddit',
  name: 'Reddit',
  iconIndex: PlatformRegistry.reddit.index,
  color: PlatformRegistry.reddit.color,
  buildUrl: (content: ShareContent): string => {
    return buildShareUrl('https://www.reddit.com/submit', {
      url: content.url,
      title: content.title,
    });
  },
};

